import axios, { AxiosResponse } from "axios";
import { Cookies } from "react-cookie";
import { removeCookieAndReload } from "./axios";
import { ENDPOINTS_AUTH, URL_AUTH } from "@/constants/api_endpoints";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "@/constants/cookieNames";
import { IRefreshTokenResponse } from "@/types/authTypes";
import { IResponse } from "@/types/statusTypes";

async function fetchWithTokenRefresh(url: RequestInfo | URL, init?: RequestInit) {
	const options: RequestInit = {
		...init,
		headers: {
			...init?.headers,
			"x-access-token": new Cookies().get(ACCESS_TOKEN),
		},
	};
	let response = await fetch(url, options);

	// перехват ошибки 401
	if (response.status === 401) {
		// обновление токена
		try {
			const authResponse: AxiosResponse<IRefreshTokenResponse | IResponse> = await axios.get(`${URL_AUTH}/${ENDPOINTS_AUTH.REFRESH}`, {
				headers: {
					"x-refresh-token": new Cookies().get(REFRESH_TOKEN),
				},
			});
			if (typeof authResponse.data !== "string") {
				if ("x-access-token" in authResponse.data) {
					new Cookies().set(ACCESS_TOKEN, authResponse.data["x-access-token"], { path: "/", maxAge: 86_400 }); // на сутки
					new Cookies().set(REFRESH_TOKEN, authResponse.data["x-refresh-token"], { path: "/", maxAge: 2_592_000 }); // на месяц
				}
				if ("error" in authResponse.data) {
					removeCookieAndReload();
				}
			} else {
				removeCookieAndReload();
			}
			response = await fetch(url, options);
		} catch (error) {
			console.error(error);
			removeCookieAndReload();
		}
	}

	return response;
}

export default fetchWithTokenRefresh;
